<app-si-dialog [header]="initialData.title" modalFooterClasses="si-dialog__footer--centered">
	<ng-template appDialogBody>
		<form class="p-6" [formGroup]="requestResearchForm" (ngSubmit)="submitPrompt()" novalidate>
			<div class="add-form">
				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-full px-2" *ngIf="!initialData.isRequestResarch">
						<mat-form-field *ngIf="initialData.mandatoryInput" appearance="outline" class="mb-2 w-full">
							<mat-label>{{initialData.labelText}}</mat-label>
							<textarea matInput rows="4" cols="50" formControlName="inputValue"
									  placeholder="{{initialData.placeHolderText}}"
									  required="{{initialData.mandatoryInput}}"></textarea>
						</mat-form-field>
						<mat-form-field appearance="outline" class="mb-2 w-full">
							<mat-label>Request Name (optional)</mat-label>
							<input matInput type="text" #myInput [maxlength]="maxLength"
								   placeholder="Request Name (optional)" formControlName="requestName" />
							<span matSuffix>{{myInput.value.length}}/{{maxLength}}</span>
						</mat-form-field>
					</div>
					<div class="w-full md:flex-none md:w-full px-2" *ngIf="initialData.isRequestResarch">
						<div class="ml-12 mr-12">
							<label *ngIf="!(accountAttributesEnum.ACCURACYTIERS | hasAccess)" class="block text-center control-label ml-6 mr-6">
								Our Research on Demand team will get right on this! Give your request a name below to help
								you identify it later.
							</label>
							<label *ngIf="accountAttributesEnum.ACCURACYTIERS | hasAccess" class="block text-center control-label ml-6 mr-6">
								{{initialData.numberOfContacts | number}} {{ initialData | contactVerification }} contacts will be submitted for {{ initialData.expressRod ? 'email' : 'full' }} verification. Give your request a name below to help you identify it later.
							</label>
						</div>
						<mat-form-field appearance="outline" class="mb-2 w-full">
							<mat-label>Request Name (optional)</mat-label>
							<input matInput type="text" #myInput [maxlength]="maxLength"
								   placeholder="Request Name (optional)" formControlName="requestName" />
							<span matSuffix>{{myInput.value.length}}/{{maxLength}}</span>
						</mat-form-field>
					</div>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template appDialogFooter>
		<ng-container *ngIf="initialData.closeButtonText">
			<button matButton="outlined" type="button"
					(click)="closeModal()">{{initialData.closeButtonText}}</button>
			<button matButton="filled" type="submit"
					[disabled]="requestResearchForm.invalid" (click)="submitPrompt()">{{initialData.saveButtonText}}</button>
		</ng-container>
	</ng-template>
</app-si-dialog>
